<template>
  <span>
    <span v-if="!status" class="userStatus disabled">禁用</span>
    <span v-if="status === 1" class="userStatus enabled">启用</span>
  </span>
</template>

<script>
export default {
  props: {
    status: {
      type: Number,
      default: 0
    }
  }
};
</script>

<style scoped>
.userStatus {
  display: inline-block;
  border-radius: 35px;
  text-align: center;
  padding: 2px 10px;
}
.enabled {
  background: rgba(25, 190, 107, 0.1);
  border: 1px solid #19BE6B;
  color: #19BE6B;
}
.disabled {
  background: rgba(255, 113, 102, 0.12);
  border: 1px solid #FF7166;
  color: #FF7166;
}
</style>
